.section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mobileList {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.desktopListPanel {
  background: var(--bg-panel);
  border-radius: var(--r-14);
  overflow: hidden;
}

.flyerGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 1200px) {
  .flyerGrid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
